module.exports = ".mat-form-field {\n  width: 170px; }\n"